// imports section Start
import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
// imports section End

export default function DialogConfirm({
  open,
  onClose,
  onConfirm,
  title,
  message,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: theme.palette.system.danger,
            color: theme.palette.background.paper,
            textTransform: "capitalize",
            borderRadius: 2,
            width: "100px",
            px: 3,
            "&:hover": {
              backgroundColor: theme.palette.system.danger,
            },
          }}
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          autoFocus
          color="primary"
          sx={{
            background: theme.palette.primary.main,
            color: theme.palette.text.buttontxt,
            textTransform: "capitalize",
            borderRadius: 2,
            width: "100px",
            px: 3,
            "&:hover": {
              background: theme.palette.primary.main,
            },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
